import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { debounceTime, map, tap } from 'rxjs';
import { IMilestone, IProject, IRisk, IStakeholder, IUpdateStakeholderPayload, ITeamMember } from '../interfaces/models/project.model';

@Injectable({
  providedIn: 'root'
})
export class ProjectService {
  constructor(private http: HttpClient) { }
  private domain = environment.domain;

  getListProjects(strategyId: number) {

    return this.http.get<IProject[]>(this.domain + `strategies/${strategyId}/projects`).pipe(map((data: any) => {
      return data['data']['projects'] as IProject[];
    }))
  }
  getListPaginatedProjects(strategyId: number, paramsObj: any = {}) {
    let params = new HttpParams();
    for (let key in paramsObj) {
      if (paramsObj.hasOwnProperty(key) && paramsObj[key] !== '' && paramsObj[key] !== null && paramsObj[key] !== undefined) {
        params = params.append(key, paramsObj[key]);
      }
    }
    return this.http.get<IProject[]>(this.domain + `strategies/${strategyId}/projects`, { params: params })
  }

  getProjectStatistics(strategyId: number) {
    return this.http.get(this.domain + `strategies/${strategyId}/projects/statistics`)
  }
  getProject(strategyId: number, projectId: number) {
    return this.http.get(this.domain + `strategies/${strategyId}/projects/${projectId}`).pipe(map((data: any) => {
      return data['data']['project'] as IProject;
    }))
  }

  getStrategicRelations(strategyId: number) {
    return this.http.get(this.domain + `strategies/${strategyId}/projects/strategic-relations`).pipe(map((data: any) => {
      const payload = data?.['data'];
      if (payload) {
        payload.goals = (payload.goals ?? []).filter((g: any) => !g?.is_deleted);
        payload.pillars = (payload.pillars ?? []).filter((p: any) => !p?.is_deleted);
        payload.indicators = (payload.indicators ?? []).filter((i: any) => !i?.is_deleted);
      }
      return data;
    }))
  }

  deleteProject(strategyId: number, projectId: number) {
    return this.http.delete(this.domain + `strategies/${strategyId}/projects/${projectId}`);
  }
  createProjects(model: any, strategyId: number) {
    return this.http.post(this.domain + `strategies/${strategyId}/projects`, model).pipe(map((data: any) => {
      return data;
    }))
  }

  updateProject(model: any, strategyId: number, projectId: number) {
    return this.http.put(this.domain + `strategies/${strategyId}/projects/${projectId}`, model).pipe(map((data: any) => {
      console.log("put data");
    }))
  }

  //stakeholder
  updateStakeholders(model: IUpdateStakeholderPayload, strategyId: number, projectId: number, stackholderId: number) {
    return this.http.put(this.domain + `strategies/${strategyId}/projects/${projectId}/stakeholders/${stackholderId}`, model).pipe(map((data: any) => {
      return data;
    }))
  }

  //teamMember
  ListTeamMembers(strategyId: number, projectId: number) {
    return this.http.get(this.domain + `strategies/${strategyId}/projects/${projectId}/team-members`).pipe(map((response: any) => {
      return response['data']['teamMembers'] as ITeamMember[]
    }))
  }
  createTeamMember(strategyId: number, projectId: number, model:
    {
      user_id: number
      is_primary_connection: boolean
      activity: string
    }) {
    return this.http.post(this.domain + `strategies/${strategyId}/projects/${projectId}/team-members`, model).pipe(tap((response: any) => {
      console.log("create Team Member response", response);;
    }))
  }
  updateTeamMember(strategyId: number, projectId: number, teamMemberId: number, model:
    {
      user_id: number
      is_primary_connection: boolean
      activity: string
    }) {

    return this.http.put(this.domain + `strategies/${strategyId}/projects/${projectId}/team-members/${teamMemberId}`, model).pipe(tap((response: any) => {
      console.log("update Team Member response", response);;
    }))
  }
  deleteTeamMember(strategyId: number, projectId: number, teamMemberId: number) {
    return this.http.delete(this.domain + `strategies/${strategyId}/projects/${projectId}/team-members/${teamMemberId}`)
  }

  // Team Units (Departments/Sections)
  getTeamUnits(strategyId: number, projectId: number) {
    return this.http.get(this.domain + `strategies/${strategyId}/projects/${projectId}/team-units`)
  }

  createTeamUnit(strategyId: number, projectId: number, data: any) {
    return this.http.post(this.domain + `strategies/${strategyId}/projects/${projectId}/team-units`, data)
  }

  updateTeamUnit(strategyId: number, projectId: number, id: number, data: any) {
    return this.http.put(this.domain + `strategies/${strategyId}/projects/${projectId}/team-units/${id}`, data)
  }

  deleteTeamUnit(strategyId: number, projectId: number, id: number) {
    return this.http.delete(this.domain + `strategies/${strategyId}/projects/${projectId}/team-units/${id}`)
  }

  // /strategies/1/projects/59/resources
  updateResource(strategyId: number, projectId: number, resourceId: number, model: any) {
    return this.http.put(this.domain + `strategies/${strategyId}/projects/${projectId}/resources/${resourceId}`, model).pipe(tap((response: any) => {
      return console.log('put Milestone response update Resource:', response);
    }))
  }
  //risks
  createRisk(strategyId: number, projectId: number, model: any) {
    return this.http.post(this.domain + `strategies/${strategyId}/projects/${projectId}/risks`, model).pipe(tap((response: any) => {
      return console.log('ListRisks', response);
    }))
  }
  deleteRisk(strategyId: number, projectId: number, riskId: number) {
    return this.http.delete(this.domain + `strategies/${strategyId}/projects/${projectId}/risks/${riskId}`).pipe(tap((response: any) => {
      return console.log('ListRisks', response);
    }))
  }

  updateRisk(strategyId: number, projectId: number, riskId: number, model: IRisk) {
    return this.http.put(this.domain + `strategies/${strategyId}/projects/${projectId}/risks/${riskId}`, model).pipe(tap((response: any) => {
      return console.log('ListRisks', response);
    }))
  }
  //List Milestones
  ListMilestones(strategyId: number, projectId: number) {
    return this.http.get(this.domain + `strategies/${strategyId}/projects/${projectId}/milestones`).pipe(tap((response: any) => {
      return console.log('ListMilestones', response);
    }))
  }

  ListMilestonesWithPatrent(strategyId: number, projectId: number) {
    return this.http.get(this.domain + `strategies/${strategyId}/projects/${projectId}/milestones/milstoneWithParent`).pipe(tap((response: any) => {
      return console.log('ListMilestones', response);
    }))
  }
  createMilestones(strategyId: number, projectId: number, model: IMilestone) {
    return this.http.post(this.domain + `strategies/${strategyId}/projects/${projectId}/milestones`, model).pipe(tap((response: any) => {
      return console.log('create Milestone response :', response);
    }))
  }
  deleteMilestones(strategyId: number, projectId: number, milestoneId: number) {
    return this.http.delete(this.domain + `strategies/${strategyId}/projects/${projectId}/milestones/${milestoneId}`).pipe(tap((response: any) => {
      return console.log('delete Milestone response :', response);
    }))
  }
  updateMilestones(strategyId: number, projectId: number, milestoneId: number, model: IMilestone) {
    return this.http.put(this.domain + `strategies/${strategyId}/projects/${projectId}/milestones/${milestoneId}`, model).pipe(tap((response: any) => {
      return console.log('delete Milestone response :', response);
    }))
  }
  uploadOutputFileMilestone(strategyId: number, projectId: number, milestoneId: number, model: any) {
    return this.http.post(this.domain + `strategies/${strategyId}/projects/${projectId}/milestones/${milestoneId}/outputs`, model).pipe(tap((response: any) => {
      return console.log('upload Milestone output file response :', response);
    }))
  }
  listOutputFileMilestone(strategyId: number, projectId: number, milestoneId: number) {
    return this.http.get(this.domain + `strategies/${strategyId}/projects/${projectId}/milestones/${milestoneId}/outputs`).pipe(tap((response: any) => {
      return console.log('list  Milestone output file response :', response);
    }))
  }
  downloadMilestonOutput(strategyId: number, projectId: number, milestoneId: number, outputId: number) {
    return this.http.get(this.domain + `strategies/${strategyId}/projects/${projectId}/milestones/${milestoneId}/outputs/${outputId}`, {
      responseType: 'blob'
    }).pipe(tap((response: any) => {
      return console.log('download  Milestone output file response :', response);
    }))
  }
  deleteMilestonOutput(strategyId: number, projectId: number, milestoneId: number, outputId: number) {
    return this.http.delete(this.domain + `strategies/${strategyId}/projects/${projectId}/milestones/${milestoneId}/outputs/${outputId}`).pipe(tap((response: any) => {
      return console.log('delete  Milestone output file response :', response);
    }))
  }
  //utilty
  ListProjectsRelations(strategyId: number, projectId: number) {
    return this.http.get(this.domain + `strategies/${strategyId}/projects/${projectId}/relations`);
  }
  //submissions
  ListSubmission(strategyId: number, projectId: number) {
    return this.http.get(this.domain + `strategies/${strategyId}/projects/${projectId}/submissions`)
  }
  CreateSubmission(strategyId: number, projectId: number) {
    return this.http.post(this.domain + `strategies/${strategyId}/projects/${projectId}/submissions`, {} as any).pipe(tap((response: any) => {
      return console.log('Create Submission Response :', response);
    }))
  }
  UpdateSubmission(strategyId: number, projectId: number, submissionId: number, model: any) {
    return this.http.put(this.domain + `strategies/${strategyId}/projects/${projectId}/submissions/${submissionId}`, model).pipe(tap((response: any) => {
      return console.log('Create Submission Response :', response);
    }))
  }
  GetCompletionStatus(strategyId: number, projectId: number) {
    return this.http.get(this.domain + `strategies/${strategyId}/projects/${projectId}/completion`);
  }
  listSubmissionCriterias(strategyId: number, projectId: number, submissionId: number) {
    return this.http.get(this.domain + `strategies/${strategyId}/projects/${projectId}/submissions/${submissionId}/criterias`);
  }
  UpdateEffectsandStudies(strategyId: number, projectId: number, model: {
    positive_effects: string
    supporting_models_studies: string
  }) {
    return this.http.patch(this.domain + `strategies/${strategyId}/projects/${projectId}/update-effects-and-studies`, model);

  }
  //project Management Changes

  createManagementChanges(strategyId: number, projectId: number, model: {
    "is_on_hold": boolean,
    "reasons": string
  }) {
    return this.http.post(this.domain + `strategies/${strategyId}/projects/${projectId}/management`, model);
  }
  ListManagementChanges(strategyId: number, projectId: number) {
    return this.http.get(this.domain + `strategies/${strategyId}/projects/${projectId}/management`);
  }

  getProjectsFileAuditor(strategyId: number) {
    return this.http.get(this.domain + `strategies/${strategyId}/auditor/projects`);
  }

  getProjectMilestoneFilesAuditor(strategyId: number, projectId: number) {
    return this.http.get(this.domain + `strategies/${strategyId}/auditor/projects/${projectId}/milestones`);
  }

  reviewAuditFile(strategyId: number, auditFile: any) {
    console.log("auditFile ##", auditFile);
    return this.http.put(this.domain + `strategies/${strategyId}/auditor/${auditFile.id}`, auditFile);
  }
  listSingleMilestoneFiles(strategyId: number, projectId: number, auditFile: number) {
    return this.http.get(this.domain + `strategies/${strategyId}/auditor/projects/${projectId}/milestones/${auditFile}`);
  }
  GetMilestoneStatus(strategyId: number, projectId: number, milestoneId: number) {
    return this.http.get(this.domain + `strategies/${strategyId}/projects/${projectId}/milestones/${milestoneId}/status`);
  }
  ListGoalsProjects(strategyId: number, goalId: number) {
    return this.http.get(this.domain + `strategies/${strategyId}/goals/${goalId}/projects`);
  }

  UpdateActualRiskClosureDate(strategyId: number, projectId: number, riskId: number, actualDate: string) {
    return this.http.patch(this.domain + `strategies/${strategyId}/projects/${projectId}/risks/${riskId}/closure-date`, {
      actual_risk_closure_date: actualDate
    });
  }
  downloadReferenceFile(strategyId: number, projectId: number, govLinkageId: number, referenceFileId: number) {
    return this.http.get(this.domain + `strategies/${strategyId}/projects/${projectId}/gov-linkages/${govLinkageId}/reference-files/${referenceFileId}`, {
      responseType: 'blob'
    }).pipe(tap((response: any) => {
      return console.log('download  ref  file');
    }))
  }
  listMessages(strategyId: number, projectId: number) {
    return this.http.get(this.domain + `strategies/${strategyId}/projects/${projectId}/messages`)
  }
  createMessage(strategyId: number, projectId: number, message: string) {
    return this.http.post(this.domain + `strategies/${strategyId}/projects/${projectId}/messages`, {
      message
    })
  }

  // Department Approvals
  getDepartmentPendingProjects(strategyId: number, page: number = 1, pageSize: number = 10) {
    return this.http.get(this.domain + `strategies/${strategyId}/projects/pending-department-approval`, {
      params: {
        page: page.toString(),
        page_size: pageSize.toString()
      }
    })
  }

  approveProject(strategyId: number, projectId: number, data: any) {
    return this.http.post(this.domain + `strategies/${strategyId}/projects/${projectId}/submissions/approve`, data)
  }
}














